export const FETCH_ROLES = "FETCH_ROLES";
export const FETCH_ROLES_START = "FETCH_ROLES_START";
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_ERROR = "FETCH_ROLES_ERROR";

export const fetchRoles = () => {
    return {
        type: FETCH_ROLES,
    };
};